<template>
  <v-form ref="eventForm" v-model="valid" lazy-validation>
    <v-container grid-list-xl text-xs-center>
      <v-flex class="text-xs-left">
        <v-icon large>ti-list</v-icon>
        <h1
          v-if="!this.newEventId"
          :style="`color: ${$vuetify.theme.primary}`"
          headline
          class="headText text-xs-left"
        >{{$translate('NEW_EVENT')}}</h1>
        <h1
          v-else
          :style="`color: ${$vuetify.theme.primary}`"
          headline
        >{{$translate('EDITING')}} "{{eventForm.Name}}"</h1>
      </v-flex>
      <v-card class="elevation-0 scrollableWizard">
        <v-layout row wrap justify-space-around>
          <v-flex class="topElements" xs5>
            <h3 class="text-xs-left">{{$translate('EVENT_NAME')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.Name"
              required
              :rules="eventRule"
              clearable
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex class="topElements" xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_NAME_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex class="topElements" xs5>
            <h3 class="text-xs-left">{{$translate('EVENT_CAP_SHORT')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.MaxEventCapacity"
              min="0"
              type="number"
              required
              :rules="inputNumberRules"
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex class="topElements" xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_CAP_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5>
            <h3 class="text-xs-left">{{$translate('EVENT_TYPE')}}</h3>
            <v-select
              class="maxTextHeight"
              disabled
              v-model="eventForm.Type"
              :items="types"
              required
              :rules="eventRule"
              outline
            ></v-select>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_TYPE_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 v-if="eventForm.Type == 'OrderEvent'">
            <h3 class="text-xs-left">{{$translate('DELIVERY_PARTNER')}}</h3>
            <v-text-field
              rows="1"
              auto-grow
              class="maxTextHeight"
              :label="$translate('DELIVERY_PARTNER')"
              v-model="eventForm.DeliveryPartner"
              outline
              required
              :rules="eventRule"
              item-text="label"
              item-value="value"
            />
          </v-flex>
          <v-flex xs1 v-if="eventForm.Type == 'OrderEvent'">
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_TYPE_INFO')}}</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs5>
            <h3 class="text-xs-left">{{$translate('EVENT_TW_SHORT')}}</h3>
            <v-select
              class="maxTextHeight"
              :items="timeWindowType"
              required
              :disabled="userIsEditingEvent"
              outline
              v-model="eventForm.TimeWindowType"
              :rules="eventRule"
            ></v-select>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_TW_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('EVENT_LOC_SHORT')}}</h3>
            <v-select
              class="maxTextHeight"
              v-model="eventForm.LocationId"
              :items="locations"
              item-text="name"
              item-value="locationId"
              clearable
              outline
              required
              :rules="eventRule"
            ></v-select>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_LOC_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('EVENT_PARTOF_SHORT')}}</h3>
            <v-select
              class="maxTextHeight"
              chips
              v-model="selectedThemes"
              :items="themes"
              item-text="Name"
              item-value="EventId"
              clearable
              outline
              multiple
            ></v-select>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_PARTOF_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('EVENT_BUDGET_SHORT')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.EventBudget"
              min="0"
              type="number"
              :rules="inputNumberRules"
              prepend-inner-icon="€"
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_BUDGET_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('LEAD_TIME')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.LeadTime"
              min="0"
              :rules="inputNumberRules"
              type="number"
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_LEAD_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('COOLDOWN_TIME')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.CooldownTime"
              min="0"
              :rules="inputNumberRules"
              type="number"
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_COOL_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12 md5 class="inputField">
            <h3 class="text-xs-left">Info-video EMBED</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.InfoUrl"
              single-line
              text-truncate
              label="Info-video EMBED"
              rows="1"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_YT_LINK_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('DURATION')}}</h3>
            <v-text-field
              class="maxTextHeight"
              v-model="eventForm.Duration"
              min="0"
              :rules="inputNumberRules"
              type="number"
              single-line
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('DURATION_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 class="inputField">
            <h3 class="text-xs-left">{{$translate('EVENT_DESC_SHORT')}}</h3>
            <v-textarea
              class="maxTextHeight"
              v-model="eventForm.Description"
              required
              :rules="eventRule"
              outline
              rows="6"
              single-line
            ></v-textarea>
          </v-flex>
          <v-flex xs1>
            <v-tooltip max-width="250" bottom>
              <v-icon large class="infoPosition" slot="activator">info</v-icon>
              <span>{{$translate('EVENT_DESC_INFO')}}</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs5 md6>
            <h3 class="text-xs-left infoText"></h3>
            <event-image-loader
              class="imageBorder"
              :properties="properties2"
              v-on:load_image="setImageElement"
            ></event-image-loader>
          </v-flex>
          <v-flex>
            <v-layout column align-start>
              <v-flex>
                <v-checkbox
                  label="Managed by planboard"
                  color="primary"
                  hide-details
                  v-model="eventForm.PlanboardManaged"
                />
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
                <v-tooltip bottom>
                  <v-btn
                    :disabled="eventForm.Type == 'Theme'"
                    round
                    slot="activator"
                    color="secondary"
                    class="v-btn-5 dialogButton text-capitalize"
                    @click="showPriceCategories"
                  >
                    <v-icon class="mr-2">ti-ticket</v-icon>Ticket types
                  </v-btn>
                  <span>Ticket types</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    :disabled="eventForm.Type == 'Theme'"
                    round
                    slot="activator"
                    color="secondary"
                    class="v-btn-5 dialogButton text-capitalize"
                    @click="showBookingPolicies"
                  >
                    <v-icon class="mr-2">ti-archive</v-icon>Booking policies
                  </v-btn>
                  <span>Booking policies</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <v-dialog persistent v-model="priceCategoriesDialog" max-width="750">
        <v-layout column wrap>
          <v-card class="ticketCard elevation-2">
            <v-card xs12 class="elevation-0 pa-2">
              <h2>Some explanation about ticket types</h2>
              <v-checkbox
                v-model="externallyPriced"
                label="Pricing is externally managed"
                color="primary"
                hide-details
              />
              <h3
                v-if="externallyPriced"
              >Because the pricing is externally managed, there is no possibility to add ticket</h3>
              <v-btn
                v-if="externallyPriced"
                round
                color="secondary"
                class="text-capitalize"
                @click="priceCategoriesDialog = false"
              >{{$translate('CLOSE')}}</v-btn>
            </v-card>
            <v-card xs12 class="pa-2 typeTicketCard elevation-0">
              <v-card
                v-if="!externallyPriced"
                class="elevation-0 discountCard"
              >
                <v-toolbar flat color="white">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="text-capitalize"
                    color="secondary"
                    round
                    @click="addNewPriceCategory()"
                  >New ticket type</v-btn>
                </v-toolbar>
                <v-data-table
                  :headers="priceCategoriesHeaders"
                  :items="eventPriceCategories"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.Name }}</td>
                    <td class="text-xs-left">{{ props.item.Description }}</td>
                    <td class="text-xs-center">
                      <v-checkbox
                        class="ml-4 mt-2"
                        disabled
                        v-model="props.item.CapacityManaged"
                      ></v-checkbox>
                    </td>
                    <td v-if="props.item.Id !== 0" class="justify-center layout px-0">
                      <v-icon
                        small
                        class="mr-2"
                        @click="editPriceCategoriesItem(props.item)"
                      >edit</v-icon>
                      <v-icon
                        small
                        @click="savePriceCategories(props.item, false, true, true)"
                      >delete</v-icon>
                    </td>
                  </template>
                </v-data-table>
                <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                  <v-btn
                    round
                    color="secondary"
                    class="text-capitalize"
                    @click="cancelPriceCategoriesDialog"
                  >{{$translate('CLOSE')}}</v-btn>
                </v-layout>
              </v-card>
            </v-card>
          </v-card>
        </v-layout>
      </v-dialog>

      <v-dialog v-model="addPriceCategoriesDialog" max-width="500">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTicketTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedPriceCategoriesItem.Name" label="Ticket name"></v-text-field>
                </v-flex>
                <v-layout justify-end>
                  <v-flex xs8>
                    <v-checkbox
                      label="Capacity managed"
                      color="primary"
                      hide-details
                      v-model="editedPriceCategoriesItem.CapacityManaged"
                    />
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-textarea
                    solo
                    v-model="editedPriceCategoriesItem.Description"
                    label="Ticket description"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" round @click="closeAddPriceCategoriesDialog">Cancel</v-btn>
            <v-btn
              v-if="!editPriceCategorie"
              color="primary"
              round
              @click="savePriceCategories(editedPriceCategoriesItem, true, false, false)"
            >{{$translate('SAVE')}}</v-btn>
            <v-btn
              v-else
              color="primary"
              round
              @click="savePriceCategories(editedPriceCategoriesItem, false, true, false)"
            >{{$translate('SAVE')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="saveEventFirstDialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline" :style="`color: ${$vuetify.theme.primary}`">Warning</v-card-title>
          <v-card-text>
            <h3>In order to enter this page, please fill in the required data for the event and save it.</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              round
              class="text-capitalize"
              @click.native="saveEventFirstDialog = false"
            >{{$translate('CANCEL')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
            <v-dialog persistent v-model="policiesDialog" max-width="750">
              <v-layout column wrap>
                <v-card class="ticketCard elevation-2">
                  <v-card xs12 class="elevation-0 pa-2">
                    <h2>Some explanation about event policies</h2>
                  </v-card>
                  <v-card xs12 class="pa-2 typeTicketCard elevation-0">
                    <v-card class="elevation-0 discountCard">
                      <v-toolbar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn
                          class="text-capitalize"
                          color="secondary"
                          round
                          @click="addPoliciesDialog = true"
                        >New policy</v-btn>
                      </v-toolbar>
                      <v-data-table
                        :headers="policiesHeaders"
                        :items="eventPolicies"
                        class="elevation-1"
                      >
                        <template v-slot:items="props">
                          <td>{{ props.item.Name }}</td>
                          <td class="text-xs-left">{{ props.item.Description }}</td>
                          <td class="text-xs-center">{{ props.item.Timeout }}</td>
                          <td v-if="props.item.Id !== 0" class="justify-center layout px-0">
                            <v-icon small class="mr-2" @click="editPoliciesItem(props.item)">edit</v-icon>
                            <v-icon
                              small
                              @click="savePolicies(props.item, false, true, true)"
                            >delete</v-icon>
                          </td>
                        </template>
                      </v-data-table>
                      <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                        <v-btn
                          round
                          color="secondary"
                          class="text-capitalize"
                          @click="cancelPoliciesDialog"
                        >{{$translate('CLOSE')}}</v-btn>
                        <!-- <v-btn
                      round
                      color="primary"
                      class="text-capitalize"
                      @click="savePriceCategories"
                        >{{$translate('SAVE')}}</v-btn>-->
                      </v-layout>
                    </v-card>
                  </v-card>
                </v-card>
              </v-layout>
            </v-dialog>
            <v-dialog v-model="addPoliciesDialog" max-width="500">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formPoliciesTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field v-model="editedPoliciesItem.Name" label="Policy name"></v-text-field>
                      </v-flex>
                      <v-layout justify-end>
                        <v-flex xs8>
                          <v-text-field
                            label="Policy timeout (in sec)"
                            input="number"
                            min="0"
                            max="2592000"
                            v-model="editedPoliciesItem.Timeout"
                          />
                        </v-flex>
                      </v-layout>
                      <v-flex xs12>
                        <v-textarea
                          solo
                          v-model="editedPoliciesItem.Description"
                          label="Policy description"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" round @click="closeAddPoliciesDialog">Cancel</v-btn>
                  <v-btn
                    v-if="!editPolicies"
                    color="primary"
                    round
                    @click="savePolicies(editedPoliciesItem, true, false, false)"
                  >{{$translate('SAVE')}}</v-btn>
                  <v-btn
                    v-else
                    color="primary"
                    round
                    @click="savePolicies(editedPoliciesItem, false, true, false)"
                  >{{$translate('SAVE')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { ui_helpers } from "../shared/ui_helpers"; // Mandatory to reach the ShowComponents functions and other snippets
import EventImageLoader from "@/components/media/EventImageLoader"; // Mandatory to use the image wizard
import appConfig from "../../config/app_config"; // Mandatory to reach the dss objects and other info
import * as dssRequest from "../api/dssRequest"; // Mandatory to do a request for data
import LocationObject from "@/objects/LocationObject"; // Mandatory to create automated Location object
import { objectToArray } from "@/shared/utility.js"; // Mandatory to create array of objects from object of objects
import BaseObject from "@/objects/BaseObject.js"; // Mandatory to create array of objects from objject of objects
import _ from "lodash"; // Mandatory to use the lodash accessibilities

export default {
  name: "EventWizard_EventDetails",
  components: {
    // Importing the components that are used within this component
    EventImageLoader
  },
  mixins: [ui_helpers],
  props: {
    newEventId: {
      type: String
    }
  },
  computed: {
    formPoliciesTitle() {
      return this.editedPoliciesIndex === -1 ? "New policy" : "Edit policy";
    },
    formTicketTitle() {
      return this.editedPriceCategoriesIndex === -1
        ? "New ticket type"
        : "Edit ticket type";
    }
  },
  watch: {
    eventForm: {
      handler(newV, oldV) {
        // Watch on the eventform if it changes or not (to save the data or continue without saving)
        console.log("newV on eventDetails on the wizard", newV);
        this.$emit(
          "eventFormIsChanged",
          newV,
          oldV,
          this.newEventId,
          this.properties2,
          this.selectedThemes
        );
      },
      deep: true
    },
    externallyPriced(newV, oldV) {
      if ((newV = true)) {
        this.savePriceCategories();
      }
    },
    addPriceCategoriesDialog(val) {
      val || this.closeAddPriceCategoriesDialog();
    }
  },
  mounted() {

    this.checkConditionForEditing(); // Check if we are editing or creating an event
    this.getAllLocations(); // Retrieving the possible locations for the event
    this.getAllThemes(); // Retrieving the possible themes for the event
  },
  data() {
    return {
      // Variables
      typeOfEventCreation: "",
      valid: true,
      userIsEditingEvent: false,
      selectedThemes: [],
      themes: [],
      locations: [],
      recievedEventData: {},

      saveEventFirstDialog: false,

      // Price categories
      priceCategoriesDialog: false,
      externallyPriced: false,
      addPriceCategoriesDialog: false,
      editPriceCategorie: false,
      eventPriceCategories: [],
      editedPriceCategoriesIndex: -1,
      editedPriceCategoriesItem: {},
      priceCategoriesHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name"
        },
        { text: "Description", value: "Description", sortable: false },
        { text: "Capacity managed", value: "CapacityManaged", sortable: false },
        { text: "Actions", value: "Name", sortable: false }
      ],

      // Booking policies
      policiesDialog: false,
      eventPolicies: [],
      addPoliciesDialog: false,
      editPolicies: false,
      editedPoliciesIndex: -1,
      editedPoliciesItem: {},
      policiesHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name"
        },
        { text: "Description", value: "Description", sortable: false },
        { text: "Time out", value: "Timeout", sortable: false },
        { text: "Actions", value: "Name", sortable: false }
      ],

      // Event types
      types: ["Standard"],

      // Form objects
      eventForm: {},

      // Rules
      eventRule: [v => !!v || "This field is required"],
      inputNumberRules: [
        (v => !!v && v !== 0) || "This field is required",
        v => (v && v > -1) || "Must be 0 or higher"
      ],

      // Hard-coded !-- TODO make it dynamically --!
      timeWindowType: ["Fixed", "Repetitive"],

      // The properties for the add photo wizard
      properties2: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w"
      }
    };
  },
  created() {
    window.EventBus.listen("validateEventForm", this.validateEventForm);
    window.EventBus.listen(
      "setTypeOfEventCreation",
      this.setTypeOfEventCreation
    );
  },
  beforeDestroy() {
    window.EventBus.removeListener("validateEventForm", this.validateEventForm);
    window.EventBus.removeListener(
      "setTypeOfEventCreation",
      this.setTypeOfEventCreation
    );
  },
  methods: {
    setTypeOfEventCreation(type) {
      this.typeOfEventCreation = type;
      console.log("typeOfEventCreation", type);
    },
    validateEventForm() {
      let returnBool = false;
      if (!this.$refs.eventForm.validate()) {
        returnBool = false;
      } else {
        returnBool = true;
      }
      this.$emit("returnedValueForValidationForm", returnBool);
    },
    setImageElement(e) {
      // If the properties are changed, the image changes regarding the new props
      if (e.signalName == this.properties2.signalName) {
        this.properties2.pictureUrl = e.url;
      }
    },
    getAllLocations() {
      // Retrieving the locations to select a location for the event
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        FunctionId: "LocationFunctionLibrary::getLocationsV2"
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call 'getLocationsV2' on - EventWizard_EventDetails.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty('Locations')) {
            // window.EventBus.fire("triggerGenericErrorDialog", 'W_GL_001');
            return;
          }
          if (!response.hasOwnProperty("data")) {
            console.log("error, in the response is no data available");
          }
          let locationBulk = LocationObject._createArrayWithObjects(
            response.data.Locations
          );
          this.locations = locationBulk.map(E => ({
            name: E.name,
            locationId: E.locationId
          }));
        },
        error => {
          console.log(
            "The generic call 'getLocationsV2' on - EventWizard_EventDetails.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    getAllThemes() {
      // Method to get all the themes for current account
      let userLanguage = 0;
      if (this.$store.getters.getUserLanguage !== "") {
        userLanguage = this.$store.getters.getUserLanguage;
      }
      const payload = {
        LanguageTagId: Number(userLanguage)
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getEvents was successful", response);

          this.themes = [];
          if (!_.isEmpty(response.data.Events)) {
            delete response.data.Events.Children;
            for (let [key, value] of Object.entries(response.data.Events)) {
              delete value.Children;
              delete value.Description;
              delete value.EventRanking;
              delete value.EventTranslationName;
              delete value.InfoUrl;
              delete value.LocationName;
              delete value.Picture;
              delete value.Tags;
              value.EventId = key;
              this.themes.push(value);
            }
            console.log("this themes", this.themes);
          } else {
            this.themes = [];
            console.log("  Recieved data is empty ");
          }
        },
        error => {
          console.log("The generic call getEvents was not successful", error);
        },
        "getEventsV2",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    checkConditionForEditing() {
      if (!_.isEmpty(this.$store.getters.getChosenEvent)) {
        this.userIsEditingEvent = true;
        this.recievedEventData = this.$store.getters.getChosenEvent;
        setTimeout(() => {
          this.$store.commit("setChosenEvent", {});
        }, 10);
        if (!_.isEmpty(this.recievedEventData.ParentEvents)) {
          for (let [key, value] of Object.entries(
            this.recievedEventData.ParentEvents
          )) {
            this.selectedThemes.push({
              EventId: key,
              Name: value.Name
            });
          }
        } else {
          this.selectedThemes = [];
        }
        this.recievedEventData.LeadTime = (
          this.recievedEventData.LeadTime / 60
        ).toString();
        this.recievedEventData.CooldownTime = (
          this.recievedEventData.CooldownTime / 60
        ).toString();
        this.recievedEventData.Duration = (
          this.recievedEventData.Duration / 60
        ).toString();
        this.properties2.pictureUrl = this.recievedEventData.Picture;
        this.newEventId = String(this.recievedEventData.EventId);
        this.eventForm = this.recievedEventData;
      }
    },
    showPriceCategories() {
      if (!this.newEventId) {
        // Creating new event
        this.saveEventFirstDialog = true;
        return;
      } else {
        // Editing exisiting event
        this.getPriceCategories();
        this.priceCategoriesDialog = true;
      }
    },
    savePriceCategories(item, optionNew, optionUpdate, optionDelete) {
      // this.$store.commit("setNewErrorType", true);
      let payload = {};
      let toSendData = {};
      if (this.externallyPriced) {
        this.eventPriceCategories = [];
        this.toSendData = Object.assign(
          {},
          {
            EventId: Number(this.newEventId),
            Id: 0,
            Name: "Free",
            Description: "This event is free",
            CapacityManaged: true
          }
        );
        this.payload = {
          ExternalPricing: true,
          EventId: Number(this.newEventId),
          New: {
            0: this.toSendData
          }
        };
      } else {
        if (optionNew && !optionUpdate) {
          this.toSendData = Object.assign(
            {},
            {
              Name: item.Name,
              Description: item.Description,
              CapacityManaged: Boolean(item.CapacityManaged)
            }
          );
          this.toSendData.Active = false;
          this.toSendData.EventId = this.newEventId;
          this.payload = {
            ExternalPricing: false,
            EventId: Number(this.newEventId),
            New: {
              0: this.toSendData
            }
          };
        } else if (!optionNew && optionUpdate && !optionDelete) {
          this.toSendData = Object.assign(
            {},
            {
              Name: item.Name,
              Description: item.Description,
              CapacityManaged: Boolean(item.CapacityManaged)
            }
          );
          this.toSendData.Active = false;
          this.toSendData.EventId = this.newEventId;
          this.payload = {
            ExternalPricing: false,
            EventId: Number(this.newEventId),
            Update: {
              [item.Id]: this.toSendData
            }
          };
        } else if (!optionNew && optionUpdate && optionDelete) {
          this.toSendData = Object.assign(
            {},
            {
              Name: item.Name,
              Description: item.Description,
              CapacityManaged: Boolean(item.CapacityManaged)
            }
          );
          this.toSendData.Active = true;
          this.toSendData.EventId = this.newEventId;
          this.payload = {
            ExternalPricing: false,
            EventId: Number(this.newEventId),
            Update: {
              [item.Id]: this.toSendData
            }
          };
        }
      }

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        this.payload.PartnerId = -1;
      } else {
        this.payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }

      console.log("payload on savePriceCategories", this.payload);

      dssRequest.doRequest(
        response => {
          console.log(
            "The gerenic call savePriceCategories was successful",
            response
          );
          this.editPriceCategorie = false;
          this.closeAddPriceCategoriesDialog();
          this.getPriceCategories();
        },
        error => {
          console.log(
            "The generic call savePriceCategories was not successful",
            error
          );
        },
        "savePriceCategories",
        appConfig.dss.eventAdminMng,
        this.payload
      );
    },
    getPriceCategories() {
      // this.$store.commit("setNewErrorType", true);
      const payload = {
        EventId: Number(this.newEventId)
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The gerenic call getPriceCategories was successful",
            response
          );
          this.eventPriceCategories = Object.values(response.data.Tickets);
          if (this.eventPriceCategories.length == 0 && !this.externallyPriced) {
            // Adding Free if none available for the event tickets
            let x = {
              Id: 0,
              Name: "Free",
              Description: "This event is free",
              CapacityManaged: true
            };
            this.savePriceCategories(x, true, false, false);
          }
        },
        error => {
          console.log(
            "The generic call getPriceCategories was not successful",
            error
          );
        },
        "getPriceCategories",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    addNewPriceCategory() {
      this.addPriceCategoriesDialog = true;
      this.editPriceCategorie = false;
    },
    editPriceCategoriesItem(item) {
      this.editedPriceCategoriesIndex = this.eventPriceCategories.indexOf(item);
      this.editedPriceCategoriesItem = Object.assign({}, item);
      this.addPriceCategoriesDialog = true;
      this.editPriceCategorie = true;
    },
    cancelPriceCategoriesDialog() {
      if (!this.newEventId) {
        this.eventPriceCategories = [];
      }
      this.priceCategoriesDialog = false;
    },
    closeAddPriceCategoriesDialog() {
      this.addPriceCategoriesDialog = false;
      setTimeout(() => {
        this.editedPriceCategoriesItem = {};
      }, 300);
    },
    showBookingPolicies() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
        return;
      } else {
        this.getPolicies();
        this.policiesDialog = true;
      }
    },
        savePolicies(item, optionNew, optionUpdate, optionActive) {
      let payload = {};
      let toSendData = {};
      if (optionNew && !optionUpdate) {
        this.toSendData = Object.assign(
          {},
          {
            Name: item.Name,
            Description: item.Description,
            Timeout: Number(item.Timeout)
          }
        );
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          New: {
            0: this.toSendData
          }
        };
      } else if (!optionNew && optionUpdate && !optionActive) {
        this.toSendData = Object.assign(
          {},
          {
            Name: item.Name,
            Description: item.Description,
            Timeout: Number(item.Timeout)
          }
        );
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          Update: {
            [item.PolicyId]: this.toSendData
          }
        };
      } else if (!optionNew && optionUpdate && optionActive) {
        this.toSendData = Object.assign(
          {},
          {
            Name: item.Name,
            Description: item.Description,
            Timeout: Number(item.Timeout)
          }
        );
        this.toSendData.Active = false;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          Update: {
            [item.PolicyId]: this.toSendData
          }
        };
      }

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        this.payload.PartnerId = -1;
      } else {
        this.payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      dssRequest.doRequest(
        response => {
          console.log(
            "The gerenic call savePolicies was successful",
            response
          );
          this.getPolicies();
          if (this.addPoliciesDialog) this.addPoliciesDialog = false;
        },
        error => {
          console.log(
            "The generic call savePolicies was not successful",
            error
          );
        },
        "savePolicies",
        appConfig.dss.eventAdminMng,
        this.payload
      );
    },

    getPolicies() {
      const payload = {
        EventId: Number(this.newEventId)
      };
      dssRequest.doRequest(
        response => {
          console.log("The gerenic call getPolicies was successful", response);
          this.eventPolicies = Object.values(response.data);
          if (this.eventPolicies.length == 0) {
            // Adding Free if none available for the event policies
            let x = {
              Name: "Strict",
              Description: "This policy has a time-out of 30 minutes",
              Timeout: 1800,
              Active: true
            };
            this.savePolicies(x, true, false, false);
          }
        },
        error => {
          console.log(
            "The generic call getPolicies was not successful",
            error
          );
        },
        "getPolicies",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    cancelPoliciesDialog() {
      if (!this.newEventId) {
        this.eventPolicies = [];
      }
      this.policiesDialog = false;
    },
    editPoliciesItem(item) {
      this.editedPoliciesIndex = this.eventPolicies.indexOf(item);
      this.editedPoliciesItem = Object.assign({}, item);
      this.addPoliciesDialog = true;
      this.editPolicies = true;
    },
    closeAddPoliciesDialog() {

      this.addPoliciesDialog = false;
      setTimeout(() => {
        this.editedPoliciesItem = {};
      }, 300);
    },
  }
};
</script>


<style lang = "scss", scoped>
.headText {
  margin-top: -1.5em;
  margin-left: 2.2em;
  margin-bottom: 1em;
}

.scrollableWizard {
  padding-bottom: 1em;
  margin-left: 2em;
  margin-bottom: 1em;
  padding-right: 1em;
  max-height: calc(50vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.maxTextHeight {
  margin-top: -0.5em !important;
  transform: scale(0.85);
  transform-origin: left;
}

.infoPositionTop {
  margin-left: -2.8em;
  margin-bottom: -1.2em;
}

.infoPosition {
  margin-left: -2.8em;
  margin-bottom: -0.4em;
}

.inputField {
  margin-top: -2em;
}

.imageBorder {
  margin-left: 0em !important;
  max-width: 80%;
  border-radius: 2%;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.ticketCard {
  min-height: 32em;
  width: 100%;
}

.topElements {
  margin-bottom: -2em;
}

/** checks if the media window is maximum 800px **/
@media (max-height: 800px) {
  .scrollableWizard {
    margin-bottom: 1em;
    padding-right: 3em;
    max-height: calc(40vh) !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

/** checks if the media window is minimal 900px **/
@media (min-height: 900px) {
  .scrollableWizard {
    margin-bottom: 1em;
    padding-right: 3em;
    max-height: calc(45vh) !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
